export default __webpack_public_path__ + "static/media/woocommerce-wordpress.0dd4828a.png";